import { render, staticRenderFns } from "./QuickModel.vue?vue&type=template&id=5a865712"
import script from "./QuickModel.vue?vue&type=script&lang=js"
export * from "./QuickModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports